import { termsContent } from "../data/terms-content";
import SEO from "@/components/SEO";

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service | Motosport Software"
        description="Review the terms of service for using Motosport Software's platform and services."
        url="https://motosportsoftware.com/terms"
      />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <h1 className="text-[36px] font-bold leading-tight tracking-tight text-[#1F2A3A] mb-8">
          Terms of Service
        </h1>
        <div className="prose prose-lg max-w-none">
          {termsContent.sections.map((section, index) => (
            <div key={index} className="mb-8">
              <h2 className="text-2xl font-bold text-[#1F2A3A] mb-4">{section.title}</h2>
              {section.paragraphs.map((paragraph, pIndex) => (
                <p key={pIndex} className="mb-4 text-[#525A68]">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
